import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'appc-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: false,
})
export class SpinnerComponent implements OnInit {

  showLoader = false;
  constructor(private loaderService: LoaderService) {
  }

  ngOnInit() {
    this.loaderService.isLoading$.subscribe((show: boolean) => {
        setTimeout(() => {
          this.showLoader = show;
        });
    });
  }


}
